import loadingComponent from "./component/tk-loading.vue";

let instance;

export default {
  install(Vue) {
    if (!instance) {
      // 返回一个 扩展实例构造器
      const LoadingConstructor = Vue.extend(loadingComponent);
      // 生成实例
      instance = new LoadingConstructor();
      // 挂载实例
      instance.$mount(document.createElement("div"));
      document.body.appendChild(instance.$el);
    }
    const loading = {
      show(options) {
        instance.show = true;
        if (options) {
          instance.tkLoading = options;
        }
      },
      hide() {
        instance.show = false;
      }
    };
    if (!Vue.prototype.$loading) {
      Vue.prototype.$loading = loading;
    }
    Vue.mixin({
      created() {
        this.$loading = Vue.prototype.$loading;
      }
    });
  }
};
